import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import CreateDesignation from "./steps/CreateDesignation/CreateDesignation";
import CreateTeam from "./steps/CreateTeam/CreateTeam";
import YhButton from "../../../../../../ui/YhButton";
import urls from "../../../../../../global/constants/UrlConstants";
import {
  openErrorNotification,
} from "../../../../../../helpers/methods";

const stepData = [
  {
    label: "Create Department",
    sub: "Add department details",
  },
  {
    label: "Create Designation",
    sub: "Add team designation",
  },
];

interface CustomProps {
  isDialogOpen?: boolean;
  handleCloseAddTeamMetaData?: Function;
}

const AddTeamMatadata = (props: CustomProps = {}) => {
  const history = useHistory();
  const isEmbedded = props.isDialogOpen !== undefined;
  const [activeStep, setActiveStep] = useState(0);
  const [selectedDept, setSelectedDept] = useState<any>({});

  const handleClose = () => {
    setActiveStep(0);
    if (props.handleCloseAddTeamMetaData) {
      props.handleCloseAddTeamMetaData();
      return;
    }
    history.push(urls.metaListViewPath);
  };

  const nextStep = () => {
    if (activeStep === 0 && !selectedDept?._id) {
      openErrorNotification("Please select a department to continue");
      return;
    }
    setActiveStep((s) => Math.min(s + 1, stepData.length - 1));
  };

  const backStep = () => {
    if (activeStep === 0) {
      handleClose();
      return;
    }
    setActiveStep((s) => Math.max(s - 1, 0));
  };

  const formBody = (
    <div
      className={`relative flex flex-col overflow-hidden bg-white p-4 pb-0 sm:p-5 sm:pb-0 lg:p-6 lg:pb-0 ${
        isEmbedded
          ? "h-[min(90vh,880px)] w-full max-w-6xl"
          : "h-[calc(100vh-68px)] max-h-[calc(100vh-68px)]"
      }`}
    >
      <div className="mb-5 flex shrink-0 items-center justify-between gap-3">
        <div>
          <h1 className="text-2xl font-bold tracking-tight text-[#1E1B4B] sm:text-[28px]">
            Add Department Meta Data
          </h1>
          <p className="mt-1 text-sm text-[#6B7280]">
            Add or edit your department meta data
          </p>
        </div>
        <button
          type="button"
          onClick={handleClose}
          className="flex h-10 w-10 items-center justify-center rounded-xl border border-[#E5E7EB] bg-white text-[#374151] shadow-sm transition hover:bg-[#F3F4F6]"
          aria-label="Close"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M18 6L6 18M6 6l12 12" />
          </svg>
        </button>
      </div>

      {/* Horizontal stepper like screenshot */}
      <div className="mb-5 flex shrink-0 items-start justify-center gap-0 px-2">
        {stepData.map((step, index) => {
          const isActive = index === activeStep;
          const isDone = index < activeStep;
          return (
            <React.Fragment key={step.label}>
              <button
                type="button"
                onClick={() => {
                  if (index <= activeStep) setActiveStep(index);
                }}
                className="flex max-w-[220px] flex-col items-center text-center"
              >
                <span
                  className={`mb-2 flex h-9 w-9 items-center justify-center rounded-full text-sm font-bold ${
                    isActive || isDone
                      ? "bg-[#A02448] text-white"
                      : "bg-[#E5E7EB] text-[#6B7280]"
                  }`}
                >
                  {index + 1}
                </span>
                <span
                  className={`text-sm font-semibold ${
                    isActive ? "text-[#111827]" : "text-[#6B7280]"
                  }`}
                >
                  {step.label}
                </span>
                <span className="mt-0.5 text-xs text-[#9CA3AF]">{step.sub}</span>
              </button>
              {index < stepData.length - 1 ? (
                <div className="mx-3 mt-4 h-px min-w-[48px] flex-1 border-t border-dashed border-[#D1D5DB] sm:min-w-[80px]" />
              ) : null}
            </React.Fragment>
          );
        })}
      </div>

      <div className="min-h-0 flex-1 overflow-hidden pb-20">
        {activeStep === 0 ? (
          <CreateTeam
            nextStep={nextStep}
            backStep={backStep}
            handleCloseCreateTeam={handleClose}
            selectedDept={selectedDept}
            setSelectedDept={setSelectedDept}
            hideFooterButtons
          />
        ) : (
          <CreateDesignation
            backStep={backStep}
            nextStep={nextStep}
            handleCloseCreateTeam={handleClose}
            selectedDept={selectedDept}
            hideFooterButtons
          />
        )}
      </div>

      <div className="sticky bottom-0 z-20 -mx-4 mt-auto flex shrink-0 items-center justify-between gap-3 border-t border-[#EEF0F5] bg-white/95 px-4 py-3 backdrop-blur sm:-mx-5 sm:px-5 lg:-mx-6 lg:px-6">
        <YhButton
          variant="secondary"
          size="sm"
          onClick={backStep}
          startIcon={
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M15 18l-6-6 6-6" />
            </svg>
          }
        >
          Back
        </YhButton>
        <div className="flex shrink-0 items-center gap-2">
          <YhButton variant="secondary" size="sm" onClick={handleClose}>
            Cancel
          </YhButton>
          {activeStep < stepData.length - 1 ? (
            <YhButton
              variant="primary"
              size="sm"
              onClick={nextStep}
              endIcon={
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M9 18l6-6-6-6" />
                </svg>
              }
            >
              Next
            </YhButton>
          ) : (
            <YhButton
              variant="primary"
              size="sm"
              onClick={handleClose}
              endIcon={
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M9 18l6-6-6-6" />
                </svg>
              }
            >
              Next
            </YhButton>
          )}
        </div>
      </div>
    </div>
  );

  if (isEmbedded) {
    if (!props.isDialogOpen) return null;
    return (
      <div className="fixed inset-0 z-[1400] flex items-center justify-center bg-black/40 p-4">
        <div className="w-full max-w-6xl overflow-hidden rounded-2xl shadow-xl">
          {formBody}
        </div>
      </div>
    );
  }

  return formBody;
};

export default AddTeamMatadata;
